// src/pages/SolveQuestion.jsx
import React, { useState, useContext } from "react";
import { useParams } from "react-router-dom";
import ChatBox from "../components/ChatBox";
import axios from "../api/api";
import { AuthContext } from "../context/AuthContext";

const SolveQuestion = () => {
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(""); 
  const { user } = useContext(AuthContext);
  const { questionId } = useParams(); 

  const handleSend = async (userInput) => {
    if (!user) return "⚠️ Please login to solve questions.";
    if (!questionId) return "⚠️ No question selected.";

    setLoading(true);

    try {
      const response = await axios.post("/ai/solve", {
        questionId,
        search,
        userInput,
      });

      const { code, explanation, output } = response.data;

      return (
        `💡 **Explanation:**\n${explanation}\n\n` +
        (code ? `📜 **Code:**\n\`\`\`js\n${code}\n\`\`\`\n\n` : "") +
        (output ? `🖥️ **Expected Output:**\n${output}` : "")
      );
    } catch (error) {
      console.error(error);
      return "❌ Error solving question. Try again.";
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 sm:p-6 md:p-8 max-w-6xl mx-auto h-[calc(100vh-5rem)] flex flex-col">
      <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold mb-4 text-center md:text-left">
        Solve DSA Question
      </h1>

      {/* 🔍 Search box */}
      <div className="w-full flex flex-col sm:flex-row items-center gap-3 mb-4">
        <input
          type="text"
          placeholder="Search topic (e.g. Graphs, DP, Trees)"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="flex-grow w-full sm:w-auto p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm md:text-base"
        />
        <button
          onClick={() => setSearch("")}
          className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300 text-sm md:text-base"
        >
          Clear
        </button>
      </div>

      {/* ChatBox takes full height */}
      <div className="flex-grow">
        <ChatBox onSend={handleSend} />
      </div>

      {loading && (
        <p className="mt-2 text-blue-600 text-sm text-center animate-pulse">
          Processing your input...
        </p>
      )}
    </div>
  );
};

export default SolveQuestion;
